
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { BoardIVO, BoardFileIVO } from "@/views/biz/board/vo/BoardVO";
import { MemberVO } from "@/views/biz/login/vo/MemberVO.vo";
import { CommonCodeIVO, CommonCodeOVO, SelectBoxWithCodeVO } from '@/views/bizcommon/code/vo/CodeVO.vo'
import { FileMstVO, FileOVO } from "@/views/bizcommon/file/vo/FileVO";
import { EditorContent, Editor, Node } from "tiptap";
import {
  TiptapVuetify,
  Heading,
  Bold,
  Italic,
  Strike,
  Underline,
  Code,
  Paragraph,
  BulletList,
  OrderedList,
  ListItem,
  Link,
  Blockquote,
  HardBreak,
  HorizontalRule,
  History,
  Image,
  Table,
  TableHeader,
  TableCell,
  TableRow,
  TodoList,
  TodoItem,
} from "tiptap-vuetify";
import FileSelector from "@/views/biz/board/FileSelector.vue";
import Constants from "@/constants";
import CommonUtils from "@/common-utils";
import axios from "axios";

@Component({
  components: { TiptapVuetify, FileSelector, EditorContent },
})
export default class BoardForm extends Vue {
  @Prop() bmNo!: string;

  boardIVO: BoardIVO = {} as BoardIVO;
  boardContentLength = 0;
  items = [] as Array<CommonCodeOVO>;

  validForm = false;

  editor: Editor = null as Editor;
  currentContentJson;
  // 업로드 파일
  attachFiles = [] as Array<FileMstVO>;
  tmpUploadImages: Array<FileMstVO> = [] as Array<FileMstVO>; // 임시 업로드
  uploadImages: Array<FileMstVO> = [] as Array<FileMstVO>; // 최종 업로드

  member = {} as MemberVO;

  extensions = [
    History,
    Blockquote,
    Link,
    Underline,
    Strike,
    Italic,
    ListItem,
    BulletList,
    OrderedList,
    [
      Heading,
      {
        options: {
          levels: [1, 2, 3],
        },
      },
    ],
    Bold,
    Code,
    HorizontalRule,
    Table,
    TableHeader,
    TableCell,
    TableRow,
    Paragraph,
    HardBreak,
    [
      Image,
      {
        options: {
          imageSources: [{ component: FileSelector, name: "File Selector" }],
          imageSourcesOverride: true,
        },
      },
    ],
  ];

  selectRules = [(v: string) => !!v || "작성할 게시판을 선택해주세요."];

  titleRules = [
    (v: string) => !!v || "제목을 입력해주세요.",
    (v: string) => (!!v && v.length <= 100) || "100자 이내로 입력해주세요.",
  ];

  contentRules = [(v: string) => !!v || "내용을 입력해주세요."];

  get groupByBoardType() {
    return this.items.filter(v=> {
      if(!v.writeRole || (v.writeRole && v.writeRole <= this.member.mrRole)) {
        return v;
      }
    }).map((v: CommonCodeOVO)=> {
      

      const item = {} as SelectBoxWithCodeVO;

      if(v.lvl == '1') {
        item.header = v.codeNm;
      }
      else {
        item.text = v.codeNm;
        item.value = v.codeNo;
        item.group = v.codeRefNm;
      }

      return item;
    })
  }

  // 저장
  async saveForm() {
    if (
      this.validForm &&
      this.boardIVO.bmContent &&
      this.boardContentLength <= 10000
    ) {
      const res = await this.$confirm(
        "저장 하시겠어요?",
        CommonUtils.baseConfirmOption
      );

      if(!res) {
        return;
      }

      // 저장할 파일만 추출
      this.boardIVO.images = this.getUploadFilesFromEditor();
      this.boardIVO.images.push(...this.attachFiles)

      // 저장
      if(!this.boardIVO.bmNo) {
        axios.post("/board", this.boardIVO).then((r) => {
          this.$router.push({ name: "Board", params: { tab: "boards" } });
        });
      }

      // 수정
      if(this.boardIVO.bmNo) {
        axios.put("/board", this.boardIVO).then((r) => {
          this.$router.push({ name: "Board", params: { tab: "boards" } });
        });
      }

    } else {
      this.validForm = false;
    }
  }

  // 취소
  async cancel() {
    const res = await this.$confirm(
      "작성 중인 내용이 삭제될 수 있어요. 취소 하실건가요?",
      CommonUtils.baseConfirmOption
    );
    if (res) {
      this.$router.push({ name: "Board" });
    }
  }

  // 이미지 선택
  selectPhoto(): void {
    (this.$refs.boardFile as HTMLElement).click();
  }

  // 파일 선택
  selectFile(): void {
    (this.$refs.boardFile2 as HTMLElement).click();
  }

  // 이미지 업로드
  async changeBoardPhoto(e) {
    const formData = new FormData();
    for(const file of e.target.files) {
      if(!file.type.match(e.target.accept)) {
        alert('이미지 파일만 가능해요');
        return;
      }

      formData.append("files", file);
    }
    
    formData.append("fileType", "boards");
    await axios.post("/common/upload-files", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      }).then((r) => {
        const result = r.data;

        for(const file of result) {
          const uploadFile = file.file;

          const img = {
            constent: "inline*",
            type: "image",
            attrs: {
              src: uploadFile.fmUrl,
              alt: file.fileName,
              title: file.fileOrgNm,
            },
          };
  
          this.currentContentJson = this.editor.getJSON();
  
          this.currentContentJson.content.push(img);
          // 이미지 등록 후 개행처리
          this.currentContentJson.content.push({type: 'paragraph'});
          this.editor.setContent(this.currentContentJson, true);
  
          // 게시판 파일 관리 테이블에도 넣어주기 위한 작업(나중에 앱 바꾸면 이것도 다 없앨거임) 앱에서 쓰는 테이블임(BRD_FILE)
          // * 이미지를 업로드하면 무조건 저장한다.
          // 그리고 최종 글 등록 시 업로드 이미지를 다시 추출한다.
          // 업로드 후 에디터에서 이미지를 삭제할 경우 실제 DB에 저장할 파일 코드를 알 수가없어서..
          this.tmpUploadImages.push(uploadFile);
  
  
          this.editor.focus();
          this.$toast('업로드가 완료됐어요')
        }
      });
  }

  async changeBoardFile(e) {
    const formData = new FormData();
    for(const file of e.target.files) {
      if(e.target.accept.indexOf(e.target.files[0].type) ==-1) {
        alert('업로드가 불가한 확장자가 포함됐어요');
        return;
      }

      formData.append("files", file);
    }
    
    formData.append("fileType", "boards");

    await axios
      .post("/common/upload-files", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((r) => {
        const result = r.data;

        for(const file of result) {
          const uploadFile = file.file;

          this.attachFiles.push(uploadFile);
          this.editor.focus();
          this.$toast('업로드가 완료됐어요');
          this.$vuetify.goTo(document.body.scrollHeight, {duration: 500})
        }
      });
  }


  // 첨부파일 삭제
  async removeAttachFile(index: number) {
    const res = await this.$confirm( "첨부된 파일을 삭제하시겠어요?", CommonUtils.baseConfirmOption);

    if(!res) {
      return;
    }

    this.attachFiles.splice(index, 1);
  }

  // 에디터에 등록된 업로드 이미지 추출
  getUploadFilesFromEditor(): Array<FileMstVO> {
    // 현재 노출되는 에디터 데이터 조회
    this.currentContentJson = this.editor.getJSON();

    // 모든 요소를 검색하기 위해 루프
    for(const i in this.currentContentJson.content) {
      const target = this.currentContentJson.content[i];

      // 컨텐트 속성이 있다면 이미지가 있을 수 있음
      if(target.content) {
        for(const ii in target.content) {
          const content = target.content[ii];

          // 만약 이미지가 맞다면
          console.log(content)
          if(content.type == 'image') {
            // 에디터에 등록된 이미지와 임시 업로드 객체와 이름이 같다면 서버로 전송하기 위해 새로 담음
            this.tmpUploadImages.forEach((img, i) => {
              if(content.attrs.alt == img.fmCvtFileNm) {
                this.uploadImages.push(img);
              }
            })
          }
        }
      }
    }

    // 최종 업로드할 파일 정보
    return this.uploadImages;
  }

  // 에디터 초기화시 초기 내용 저장
  // 사진을 추가한다거나 추 후, setContent함수를 이용해야 할 때 기본값이 없을 경우 에러남
  async onInit(editor) {
    this.editor = editor.editor;
    if (this.bmNo) {
      await axios.get(`board/${this.bmNo}`).then((r) => {
        if (r.data) {
          this.boardIVO = r.data;
          this.tmpUploadImages = this.boardIVO.images;
          this.attachFiles = this.boardIVO.attachFiles;

        }
      });
      
      // 앱에서 쓴거라면
      if(this.boardIVO.bmContent.indexOf('<img') == -1) {
        this.currentContentJson = this.editor.getJSON();

        console.log(this.currentContentJson)

        this.tmpUploadImages.forEach(item => {
          const img = {
            constent: "inline*",
            type: "image",
            attrs: {
              src: item.fmUrl,
              alt: item.fmCvtFileNm,
              title: item.fmFileNm,
            },
          };
      
          this.currentContentJson.content.push(img);
          // 이미지 등록 후 개행처리
          this.currentContentJson.content.push({type: 'paragraph'});
        })

        this.editor.setContent(this.currentContentJson, true);
      }

      this.editor.focus;
      this.currentContentJson = this.editor.getJSON();
    }
  }

  @Watch("boardIVO.bmContent")
  changeBoardContent(e) {
    const content = e.replace(/(<([^>]+)>)/gi, "");
    this.boardContentLength = content.length;
  }

  created() {
    this.currentContentJson || (this.currentContentJson = { content: [] });

    axios.get('/member').then(r=>{
      this.member = r.data;
    })
    // 게시판 코드 목록 조회
    axios.get("/common/code/reflect", { params: {codeRef: 600} }).then((r) => {
      this.items = r.data;
    });

  }
}
